export enum FacebookSenderAction {
  typingOn = "typing_on",
  typingOff = "typing_off",
  markSeen = "mark_seen",
}
